import { readStoredExternalChannelCampaign } from '../utils/external-channel-access.util';

const CLEARED_FOR_KEY = 'campaign_cart_cleared_for';

export function campaignCodeInContext(): string {
  const stored = readStoredExternalChannelCampaign();
  if (typeof window === 'undefined') {
    return stored;
  }

  try {
    const query = (new URLSearchParams(window.location.search).get('campaign') ?? '').trim();
    return query || stored;
  } catch {
    return stored;
  }
}

export function campaignCartAlreadyCleared(code: string): boolean {
  try {
    return sessionStorage.getItem(CLEARED_FOR_KEY) === code.trim();
  } catch {
    return false;
  }
}

export function markCampaignCartCleared(code: string): void {
  try {
    sessionStorage.setItem(CLEARED_FOR_KEY, code.trim());
  } catch {
    // ignore
  }
}

/** The previous session cart must not be loaded until this campaign has been cleared. */
export function shouldSkipCampaignCartHydration(): boolean {
  const code = campaignCodeInContext();
  return !!code && !campaignCartAlreadyCleared(code);
}
